<template>
  <div>
    <!-- modal -->
    <div class="modal" tabindex="-1" role="dialog" v-if="modalMessage">
      <div class="modal-dialog" role="document">
        <div class="modal-content" :class="modalSuccess ? 'bg-success' : 'bg-danger'">
          <div class="modal-body">
            <p>{{ modalMessage }}</p>
            <button v-if="!modalSuccess" @click="closeModal" class="btn btn-secondary">Ok</button>
          </div>
        </div>
      </div>
    </div>

    <!-- upload files -->
    <card card-body-classes="table-full-width px-3">
      <h6>Importe as imagens do cardápio aqui</h6>
      <label for="formFileMultiple" class="form-label">Upload dos arquivos para importação; Apenas arquivos de imagem e arquivos PDF com no máximo 3.5Mb.</label>
      <input type="file" id="files" accept="image/*,application/pdf" class="form-control mb-2" multiple>
      <textarea v-model="extraText" class="w-100 input-ia" placeholder="Texto ou instruções extra"></textarea>
      <div class="p-1">
        <input type="checkbox" v-model="allExternal" @click="allExternal = !allExternal">
        <label class="form-check-label ml-2">Considerar todas as variações como produtos separados?</label>
      </div>

      <button class="btn btn-primary m-0" @click="processInputs" v-app-event="'dashboard-admin-menu-ai-clicked-import-button'">Processar</button>
    </card>

    <!-- transcription -->
    <card hidden="hidden" card-body-classes="table-full-width px-3" v-if="transcription !== ''">
      <h6>Transcrição (Informações detalhadas de como a IA leu o cardápio)</h6>
      <button @click="showingTranscription = !showingTranscription">Ver</button>
      <pre :hidden="!showingTranscription">{{transcription}}</pre>
    </card>

    <!-- parsed json -->
    <card card-body-classes="table-full-width px-3" v-if="result != null">
      <h6 class="mb-4">Resultado</h6>
      <input hidden @input="uploadImage" ref="prod-image" type="file" class="d-non" single>

      <div class="action-bar" v-if="result && result.itens">
        <label class="bold">Ações</label>
        <div class="action-bar-buttons">
          <button class="btn btn-primary" @click="removeAllImages(result.itens, 'tudo')" style="max-width: 250px">Remover todas as imagens</button>
          <button class="btn btn-primary" @click="removeAllImages(result.itens, 'produtos')" style="max-width: 320px">Remover todas as imagens dos produtos</button>
          <button class="btn btn-primary" @click="removeAllImages(result.itens, 'complementos')" style="max-width: 340px">Remover todas as imagens dos complementos</button>
        </div>
      </div>

      <v-collapse-group :onlyOneActive="false"><p class="header-ia">Categorias</p>
      <button type="button" class="btn-ia" @click="createItem(result, 'category')">+</button>
      <ul><transition-group name="ai-list" tag="div" > <!-- categoria de produto -->
        <li v-for="(categoria, cat_index) in result.itens" v-bind:key="categoria.uuid" class="catproduto">
          <input hidden type="text" v-model="categoria.drag_id"></input>
          <div class="d-flex mb-3">
            <div class="d-flex flex-column category-img align-items-center">
              <img alt="imagem da categoria" class="image-ia mb-1" @click="changeImage(categoria)" :src="categoria.img ? categoria.img : defaultImg" style="width: 60px; height: 60px;">
              <svg @click="clickUpload(cat_index)" class="upload-ia" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z"/>
              </svg>
            </div>
            <div class="d-flex ml-3" style="flex-direction: column;">
              <div class="d-flex align-items-center">
                <input type="text" class="input-ia" v-model="categoria.nome">
                <button type="button" @click="removeItem(result, 'category', cat_index)" class="btn-ia danger">-</button>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 24 24" class="ml-2 draghandle">
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M19 9H5c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM5 15h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1z"></path>
                </svg>
              </div>
              <input hidden type="text" class="input-ia mt-2" v-model="categoria.descricao">
            </div>
          </div>

          <p class="header-ia-3">Produtos</p>
          <button type="button" @click="createItem(categoria, 'product')" class="btn-ia">+</button>
          <ul><transition-group name="ai-list" tag="div" > <!-- produto -->
            <li v-for="(produto, prod_index) in categoria.itens" v-bind:key="produto.uuid" class="produto">
              <input hidden type="text" v-model="produto.drag_id"></input>
              <div class="d-flex mb-3">
                <div class="d-flex flex-column category-img align-items-center">
                  <img alt="imagem do produto" class="image-ia mb-2" @click="changeImage(produto)" :src="produto.img ? produto.img : defaultImg" style="width: 60px; height: 60px;">
                  <svg @click="clickUpload(cat_index, prod_index)" class="upload-ia" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                    <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z"/>
                  </svg>
                </div>
                <div class="d-flex ml-3" style="flex-direction: column">

                  <div class="d-flex align-items-center">
                    <input type="text" class="input-ia" v-model="produto.nome">
                    <button type="button" @click="removeItem(categoria, 'product', prod_index)" class="btn-ia danger">-</button>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 24 24" class="ml-2 draghandle">
                      <path fill="none" d="M0 0h24v24H0z"></path>
                      <path d="M19 9H5c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM5 15h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1z"></path>
                    </svg>
                  </div>

                  <input type="text" class="input-ia mt-2" v-model="produto.descricao" placeholder="Descrição do produto">

                  <money class="input-ia mt-2" v-model="produto.valor_venda" placeholder="Valor do produto"></money>
                  <v-collapse-wrapper v-bind:active="productShouldBeExpanded(produto)">
                    <div class="menu-ia-expandable" v-collapse-toggle @click="changeProductExpandedState(produto)">
                      {{ produto.expanded === undefined ?
                      productShouldBeExpanded(produto) ? "↑ Recolher ↑" : "↓ Expandir ↓" :
                      produto.expanded ? "↑ Recolher ↑" : "↓ Expandir ↓"
                      }}
                    </div>
                    <div class="menu-ia-expanded-content" v-collapse-content>
                      <div class="row">
                        <label class="form-check-label ml-2 mr-4">Custo:</label>
                        <money class="input-ia mt-2" v-model="produto.valor_custo" placeholder="Valor de custo do produto"></money>
                      </div>
                      <div class="row">
                        <label class="form-check-label ml-2 mr-3">Estoque:</label>
                        <input type="number" class="input-ia mt-2" v-model="produto.estoque" placeholder="Estoque">
                      </div>
                      <div class="row">
                        <label class="form-check-label ml-2 mr-2">PDV:</label>
                        <input id="cod_pdv" type="number" class="input-ia mt-2" v-model="produto.cod_pdv" placeholder="Código PDV">
                      </div>
                      <div class="row">
                        <label class="form-check-label ml-2 mr-2">CEST:</label>
                        <input id="cest_code" type="text" class="input-ia mt-2" v-model="produto.cest_code" placeholder="Código CEST"
                               :title="produto.cest_suggestion_explanation">
                      </div>
                      <div class="row">
                        <label class="form-check-label ml-2 mr-2">NCM:</label>
                        <input id="ncm_code" type="text" class="input-ia mt-2" v-model="produto.ncm_code" placeholder="Código NCM"
                        :title="produto.ncm_suggestion_explanation">
                      </div>
                      <div class="row">
                        <label class="form-check-label ml-2 mr-2">CFOP:</label>
                        <input id="cfop_code" type="number" class="input-ia mt-2" v-model="produto.cfop_code" placeholder="Código CFOP">
                      </div>
                      <div class="row">
                        <label class="form-check-label ml-2 mr-2">CST:</label>
                        <input id="cst_code" type="number" class="input-ia mt-2" v-model="produto.cst_code" placeholder="Código CST">
                      </div>
                      <div class="row">
                        <label class="form-check-label ml-2 mr-2">PIS:</label>
                        <input id="pis_code" type="number" class="input-ia mt-2" v-model="produto.cst_code" placeholder="Código PIS">
                      </div>
                      <div class="row">
                        <label class="form-check-label ml-2 mr-2">COFINS:</label>
                        <input id="cofins_code" type="number" class="input-ia mt-2" v-model="produto.cofins_code" placeholder="Código COFINS">
                      </div>
                      <div class="row">
                        <label class="form-check-label ml-2 mr-2">EAN:</label>
                        <input id="cod_ean" type="number" class="input-ia mt-2" v-model="produto.cod_ean" placeholder="Código EAN">
                      </div>
                      <div class="row">
                        <label class="form-check-label ml-2 mr-3">Img.: </label>
                        <input type="text" class="input-ia mt-2" v-model="produto.img" placeholder="Url da Imagem">
                      </div>
                      <div class="row">
                        <label class="form-check-label mr-2 ml-2">Pesável?</label>
                        <input class="mt-2" type="checkbox" v-model="produto.pesavel" @click="produto.pesavel = !produto.pesavel">
                      </div>
                    </div>
                  </v-collapse-wrapper>
                </div>
              </div>

              <p class="header-ia-2">Categoria de Complementos</p>
              <button type="button" @click="createItem(produto, 'complement_category')" class="btn-ia">+</button>
              <ul><transition-group name="ai-list" tag="div" > <!-- categoria de complemento -->
                <li v-for="(cat_complemento, comp_cat_index) in produto.itens" v-bind:key="cat_complemento.uuid" class="catcomplemento">
                  <input hidden type="text" v-model="cat_complemento.drag_id"></input>
                  <div class="d-flex mb-3">
                    <div class="d-flex" style="flex-direction: column;">
                      <div class="d-flex align-items-center">
                        <input type="text" class="input-ia" v-model="cat_complemento.nome">
                        <button type="button" @click="removeItem(produto, 'complement_category', comp_cat_index)" class="btn-ia danger">-</button>
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 24 24" class="ml-2 draghandle">
                          <path fill="none" d="M0 0h24v24H0z"></path>
                          <path d="M19 9H5c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM5 15h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1z"></path>
                        </svg>
                      </div>
                      <input type="text" class="input-ia mt-2" v-model="cat_complemento.descricao" placeholder="Descrição da categoria de complemento">
                      <v-collapse-wrapper v-bind:active="complementCategoryShouldBeExpanded(cat_complemento)">
                        <div class="menu-ia-expandable" v-collapse-toggle @click="changeComplementCategoryExpandedState(cat_complemento)">
                          {{ cat_complemento.expanded === undefined ?
                          complementCategoryShouldBeExpanded(cat_complemento) ? "↑ Recolher ↑" : "↓ Expandir ↓" :
                          cat_complemento.expanded ? "↑ Recolher ↑" : "↓ Expandir ↓"
                          }}
                        </div>
                        <div class="menu-ia-expanded-content" v-collapse-content>
                          <div>
                            <label class="form-check-label ml-2 mr-2">Mínimo:</label>
                            <input type="number" class="input-ia mt-2" v-model="cat_complemento.minimo" placeholder="Mínimo">
                          </div>
                          <div>
                            <label class="form-check-label ml-2 mr-2">Máximo:</label>
                            <input type="number" class="input-ia mt-2" v-model="cat_complemento.maximo" placeholder="Máximo">
                          </div>
                        </div>
                      </v-collapse-wrapper>
                    </div>
                  </div>

                  <p class="header-ia-2">Complementos</p>
                  <button type="button" @click="createItem(cat_complemento, 'complement')" class="btn-ia">+</button>
                  <ul><transition-group name="ai-list" tag="div" > <!-- complemento -->
                    <li v-for="(complemento, comp_index) in cat_complemento.itens" v-bind:key="complemento.uuid" class="complemento">
                      <input hidden type="text" v-model="complemento.drag_id"></input>
                      <div class="d-flex">
                        <div class="d-flex category-img flex-column align-items-center">
                          <img alt="imagem do complemento" class="image-ia mb-2" @click="changeImage(complemento)" :src="complemento.img ? complemento.img : defaultImg" style="width: 60px; height: 60px;">
                          <svg @click="clickUpload(cat_index, prod_index, comp_cat_index, comp_index)" class="upload-ia" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                            <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z"/>
                          </svg>
                        </div>

                        <div class="d-flex ml-3 flex-column">
                          <div class="d-flex align-items-center">
                            <input type="text" class="input-ia" v-model="complemento.nome">
                            <button type="button" @click="removeItem(cat_complemento, 'complement', comp_index)" class="btn-ia danger">-</button>
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 24 24" class="ml-2 draghandle">
                              <path fill="none" d="M0 0h24v24H0z"></path>
                              <path d="M19 9H5c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM5 15h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1z"></path>
                            </svg>
                          </div>

                          <input draggable="false" type="text" class="input-ia mt-2" v-model="complemento.descricao" placeholder="Descrição do complemento">

                          <money class="input-ia mt-2" v-model="complemento.valor_venda" placeholder="Valor do complemento"></money>

                          <v-collapse-wrapper v-bind:active="complementShouldBeExpanded(complemento)">
                            <div class="menu-ia-expandable" v-collapse-toggle @click="changeComplementExpandedState(complemento)">
                              {{ complemento.expanded === undefined ?
                              complementShouldBeExpanded(complemento) ? "↑ Recolher ↑" : "↓ Expandir ↓" :
                              complemento.expanded ? "↑ Recolher ↑" : "↓ Expandir ↓"
                              }}
                            </div>
                            <div class="menu-ia-expanded-content" v-collapse-content>
                              <div>
                                <label class="form-check-label ml-2 mr-3">Estoque:</label>
                                <input type="number" class="input-ia mt-2" v-model="complemento.estoque" placeholder="Estoque">
                              </div>
                              <div>
                                <label class="form-check-label ml-2 mr-2">Cód. PDV:</label>
                                <input type="number" class="input-ia mt-2" v-model="complemento.cod_pdv" placeholder="Código PDV">
                              </div>
                              <div>
                                <label class="form-check-label ml-2 mr-3">Url Img.: </label>
                                <input type="text" class="input-ia mt-2" v-model="complemento.img" @change="$forceUpdate()" placeholder="Url da Imagem">
                              </div>
                            </div>
                          </v-collapse-wrapper>
                        </div>
                      </div>
                    </li>
                  </transition-group></ul>
                </li>
              </transition-group></ul>
            </li>
          </transition-group></ul>
        </li>
      </transition-group></ul></v-collapse-group>
    </card>

    <!-- button to import to client -->
    <card card-body-classes="table-full-width px-3" v-if="result != null">
      <h6>Importar para token:</h6>
      <input type="text" class="input-ia mt-2" v-model="bearer" placeholder="Token">
      <button type="button" class="btn btn-primary" @click="importMenu">
        Importar
      </button>
      <div>
        <input type="checkbox" v-model="erase" @click="erase = !erase" v-app-event="'dashboard-admin-menu-ai-clicked-change-erase-option'">
        <label class="form-check-label ml-2 ">Apagar cardápio</label>
      </div>
    </card>

  </div>

</template>

<script>

import {
  checkProcessingStatusCache,
  fillIcons, getParsedMenuFromText,
  getParsedMenuFromTextCache,
  getTranscription,
  getTranscriptionFromPdf,
  importToClient,
  suggestNcm,
  toBase64
} from "@/services/MenuAiService";
import {dataURItoBlob, store} from "@/services/UploadService";
import {Draggable, DragOverEvent, DragStopEvent} from '@shopify/draggable';

export default {
  data() {
    return {
      defaultImg: "https://cdn-production.yooga.com.br/120201112170357YBpu1ClGH.png",
      showingTranscription: false,
      transcription: null,
      extraText: "",
      result: null,
      bearer: null,
      erase: false,
      allExternal: false,
      lastUploadClicked: null,
      draggable: {
        instance: null,
        over: null,
      },
      ncm_code: '',
      cest_code: '',
      ncm_suggestion_explanation: '',
      cest_suggestion_explanation: '',
      modalMessage: "",
      modalSuccess: false,
      modalProgress: {
        visible: false,
        currentPage: 0,
        totalPages: 0,
        errors: [],
      },
    }
  },
  methods: {

    showModal(message, success) {
      this.modalMessage = message;
      this.modalSuccess = success;
      setTimeout(() => {
        if (success) this.modalMessage = "";
      }, success ? 3000 : null);
    },
    closeModal() {
      this.modalMessage = "";
    },

    //region Ai processing
    /**
     * Process images and text to a valid json object
     * Step 1: Transcribe images to text
     * Step 2: Send text to server to be parsed
     * Step 3: Show result
     * Step 4: Load image suggestions
     *
     * if any of the steps fail, execution is halted
     * @return {Promise<void>}
     */
    async processInputs() {
      this.result = null;

      const filesElement = document.getElementById('files');
      const hasFiles = filesElement.files.length > 0;
      const hasText = this.extraText.length > 0;

      if(!hasFiles && !hasText) return this.$swal({
        title:"Erro",
        icon:"warning",
        text: 'Selecione ao menos uma imagem ou insira um texto para importar'
      });

      if(hasFiles) {
        const file = filesElement.files[0];

        if (file.type === "application/pdf") {

          const successPdf = await this.transcribePdf([file]);
          if (!successPdf) return;

          const processedResults = [];
          for (const index in this.transcription) {

            const textChunk = this.transcription[index] + "\n\n" + this.extraText;
            const successParse = await this.parseText(textChunk);

            if (!successParse) {
              console.error(`[ERRO] Falha ao processar índice ${index}`);
              return this.initDraggable();
            }
            processedResults.push(this.result);
          }

          this.result = processedResults.reduce((acc, cur) => {
            acc.itens = [...acc.itens, ...cur.itens];
            return acc;
          }, { itens: [] });

          await this.fillImages();
          await this.fillNcm();
          this.initDraggable();

          this.showModal("Cardápio (PDF) processado com sucesso", true);
          return;
        }

        const success = await this.transcribeImages();
        if(!success) return;
      }

      // Do not add unnecessary whitespace
      let readyText = "";
      if(hasText && hasFiles) readyText = this.transcription + "\n\n" + this.extraText;
      else if(hasText) readyText = this.extraText;
      else readyText = this.transcription;

      const success = await this.parseText(readyText);
      if(!success) return this.initDraggable();

      await this.fillImages();
      await this.fillNcm();
      this.initDraggable();

      this.showModal("Cardápio processado com sucesso", true);
    },

    /**
     * Transcribe all images on the "files" input and set the resulting text to the "transcription" variable
     * @return {Promise<boolean>} If the transcription was successful
     */
    async transcribeImages() {
      const loader = this.$loading.show("Transcrevendo imagens...");
      try {
        const filesElement = document.getElementById('files')
        const files = Array.from(filesElement.files);

        const data = [];
        for(let file of files) data.push({
          filename: file.name,
          data: await toBase64(file)
        });

        const req = await getTranscription(data);

        this.transcription = req.data;
        return true;

      } catch (error) {
        // Verifica se o erro tem uma resposta da API
        if (error.response && error.response.data) {
          const { title, detail } = error.response.data;

          // Exibir o erro com as informações da API
          this.$swal({
            title: title || "Erro ao transcrever imagens",
            text: detail || "Ocorreu um erro desconhecido.",
            icon: "error",
          });
        } else {
          // Erro genérico (sem resposta da API)
          this.$swal({
            title: "Erro ao transcrever imagens",
            text: "Ocorreu um erro inesperado. Tente novamente mais tarde.",
            icon: "error",
          });
        }

        return false;

      } finally { loader.hide(); }
    },

    /**
     * Transcribe all PDFs on the "files" input and set the resulting text to the "transcription" variable
     * @return {Promise<boolean>} If the transcription was successful
     */
    async transcribePdf(files) {
      const loader = this.$loading.show("Transcrevendo PDF(s)...");
      try {
        const formData = new FormData();

        files.forEach((file) => {
          formData.append("file", file);
        });

        const req = await getTranscriptionFromPdf(formData);

        this.transcription = req.data;
        return true;

      } catch (error) {
        // Verifica se o erro tem uma resposta da API
        if (error.response && error.response.data) {
          const { title, detail } = error.response.data;

          // Exibir o erro com as informações da API
          this.$swal({
            title: title || "Erro ao transcrever PDF",
            text: detail || "Ocorreu um erro desconhecido.",
            icon: "error",
          });
        } else {
          // Erro genérico (sem resposta da API)
          this.$swal({
            title: "Erro ao transcrever PDF",
            text: "Ocorreu um erro inesperado. Tente novamente mais tarde.",
            icon: "error",
          });
        }

        return false;

      } finally {
        loader.hide();
      }
    },

    /**
     * Parses text to a valid json object and sets the result to the "result" variable
     * @return {Promise<boolean>} If the parsing was successful
     */
    async parseText(text) {
      const loader = this.$loading.show("Processando texto...");
      try {
        const response = await getParsedMenuFromTextCache(text, this.allExternal);
        const uuid = response?.data?.uuid;

        if (!uuid) {
          console.error("UUID não encontrado no response.");
          return false;
        }

        let status = "processing";
        let result = null;
        let timeToWait = 10000;

        while (status === "processing") {
          await new Promise((resolve) => setTimeout(resolve, timeToWait));
          const statusResponse = await checkProcessingStatusCache(uuid);
          status = statusResponse.data.status;

          if (status === "completed") {
            result = statusResponse?.data?.result;
          }
        }

        if (!result) {
          throw new Error("Erro ao processar o texto: resultado não disponível.");
        }

        const parsedResult = this.remapResultToItens(JSON.parse(result));
        this.result = this.initUUIDs(parsedResult);

        return true;

      } catch (error) {
        // Verifica se o erro tem uma resposta da API
        if (error.response && error.response.data) {
          const { title, detail } = error.response.data;

          // Exibir o erro com as informações da API
          this.$swal({
            title: title || "Erro ao processar o texto",
            text: detail || "Ocorreu um erro desconhecido.",
            icon: "error",
          });
        } else {
          // Erro genérico (sem resposta da API)
          this.$swal({
            title: "Erro ao processar o texto",
            text: "Ocorreu um erro inesperado. Tente novamente mais tarde.",
            icon: "error",
          });
        }

        return false;

      } finally {
        loader.hide();
      }
    },

    async parseTextOLD(text) {
      const loader = this.$loading.show("Processando cardápio...");
      try {
        const req = await getParsedMenuFromText(text, this.allExternal);
        const result = this.remapResultToItens(req.data);

        this.result = this.initUUIDs(result);
        return true;

      } catch (error) {
        // Verifica se o erro tem uma resposta da API
        if (error.response && error.response.data) {
          const { title, detail } = error.response.data;

          // Exibir o erro com as informações da API
          this.$swal({
            title: title || "Erro ao processar cardápio",
            text: detail || "Ocorreu um erro desconhecido.",
            icon: "error",
          });
        } else {
          // Erro genérico (sem resposta da API)
          this.$swal({
            title: "Erro ao processar cardápio",
            text: "Ocorreu um erro inesperado. Tente novamente mais tarde.",
            icon: "error",
          });
        }

        return false;

      } finally { loader.hide(); }
    },

    async fillImages() {
      const loader = this.$loading.show("Gerando sugestão de imagens...");
      try {
        const data = this.remapResultFromItens(this.result);
        const req = await fillIcons(data);
        const result = this.remapResultToItens(req.data);

        this.result = this.initUUIDs(result);
        return true;

      } catch (error) {
        // Verifica se o erro tem uma resposta da API
        if (error.response && error.response.data) {
          const { title, detail } = error.response.data;

          // Exibir o erro com as informações da API
          this.$swal({
            title: title || "Erro ao gerar sugestões de imagem",
            text: detail || "Ocorreu um erro desconhecido.",
            icon: "error",
          });
        } else {
          // Erro genérico (sem resposta da API)
          this.$swal({
            title: "Erro ao gerar sugestões de imagem",
            text: "Ocorreu um erro inesperado. Tente novamente mais tarde.",
            icon: "error",
          });
        }

        return false;

      } finally { loader.hide(); }
    },

    async fillNcm() {
      const loader = this.$loading.show("Gerando sugestão de NCM...");
      try {
        const data = this.remapResultFromItens(this.result);
        const req = await suggestNcm(data);
        const result = this.remapResultToItens(req.data);

        result.itens.forEach((categoria) => {
          categoria.itens.forEach((produto) => {
            produto.cfop_code = produto.cfop_code || "";
            produto.cst_code = produto.cst_code || "";
            produto.pis_code = produto.pis_code || 0;
            produto.cofins_code = produto.cofins_code || 0;

            if (produto.cest_code) {
              produto.cfop_code = "5405";
              produto.cst_code = "500";
              produto.pis_code = 4;
              produto.cofins_code = 4;
            } else {
              produto.cfop_code = "5102";
              produto.cst_code = "102";
              produto.pis_code = 49;
              produto.cofins_code = 49;
            }
          });
        });

        this.result = this.initUUIDs(result);

        return true;
      } catch (error) {
        // Verifica se o erro tem uma resposta da API
        if (error.response && error.response.data) {
          const { title, detail } = error.response.data;

          // Exibir o erro com as informações da API
          this.$swal({
            title: title || "Erro ao gerar sugestões de NCM",
            text: detail || "Ocorreu um erro desconhecido.",
            icon: "error",
          });
        } else {
          // Erro genérico (sem resposta da API)
          this.$swal({
            title: "Erro ao gerar sugestões de NCM",
            text: "Ocorreu um erro inesperado. Tente novamente mais tarde.",
            icon: "error",
          });
        }

        return false;

      } finally {
        loader.hide();
      }
    },

    importMenu() {
      const loader = this.$loading.show();
      const data = this.remapResultFromItens(this.result);

      importToClient(this.bearer, data, this.erase).then(() => {
        this.$eventService.track("dashboard-admin-menu-ai-submitted-result");

        loader.hide();
        this.$swal({
          title: "Cardápio importado com sucesso",
          text: "O cardápio foi importado com sucesso para o token "
        });
      }).catch((err) => {
        this.$eventService.track("dashboard-admin-menu-ai-error-submitting-result");

        loader.hide();
        if (err.response && err.response.data) {
          const { title, detail } = err.response.data;

          // Exibir o erro com as informações da API
          this.$swal({
            title: title || "Erro ao importar cardápio",
            text: detail || "Ocorreu um erro desconhecido.",
            icon: "error",
          });
        } else {
          // Erro genérico (sem resposta da API)
          this.$swal({
            title: "Erro ao importar cardápio",
            text: "Ocorreu um erro inesperado. Tente novamente mais tarde.",
            icon: "error",
          });
        }
      }).finally(() => {
        const data = this.remapResultToItens(this.result);
        this.result = this.initUUIDs(data);
      });
    },
    //endregion

    //region Result editing
    clickUpload(cat_index, prod_index, comp_cat_index, comp_index) {
      this.$refs["prod-image"].click();

      // Category
      const category = this.result.itens[cat_index];
      if(prod_index === undefined) return this.lastUploadClicked = category;

      // Product
      const product = category.itens[prod_index];
      if(comp_index === undefined) return this.lastUploadClicked = product;

      // Complement category
      const comp_category = product.itens[comp_cat_index];
      this.lastUploadClicked = comp_category.itens[comp_index];
    },

    async uploadImage(event) {
      const loader = this.$loading.show("Fazendo upload de imagem...");
      try {
        const file = event.target.files[0];
        if(!file) return;

        const formData = new FormData();
        const dataUri = await toBase64(file);
        formData.append('file', dataURItoBlob(dataUri));
        const res = await store(formData);

        // Set image as product image and add to variations
        this.lastUploadClicked.img = res.data.url;
        if(this.lastUploadClicked.img_variacoes == null) this.lastUploadClicked.img_variacoes = [];
        this.lastUploadClicked.img_variacoes.push(res.data.url);
        this.$forceUpdate();

        event.target.value = '';

      } catch (err) {
        if (err.response && err.response.data) {
          const { title, detail } = err.response.data;

          // Exibir o erro com as informações da API
          this.$swal({
            title: title || "Erro ao enviar imagem",
            text: detail || "Ocorreu um erro desconhecido.",
            icon: "error",
          });
        } else {
          // Erro genérico (sem resposta da API)
          this.$swal({
            title: "Erro ao enviar imagem",
            text: "Ocorreu um erro inesperado. Tente novamente mais tarde.",
            icon: "error",
          });
        }
      } finally {
        this.lastUploadClicked = null;
        loader.hide();
      }
    },

    // Category, product or complement
    changeImage(model) {
      this.$eventService.track("dashboard-admin-menu-ai-clicked-change-image-icon");

      // If there are no images, return
      if(!model.img_variacoes) return;

      // If the image was never changed, set to the first image
      if(!model.index_img) model.index_img = 1;
      else model.index_img++;

      // If index is bigger than the array, reset
      if(model.index_img >= model.img_variacoes.length)
        model.index_img = 0;

      model.img = model.img_variacoes[model.index_img]
    },
    createItem(parent, type, log = true) {
      if(log) this.$eventService.track(`dashboard-admin-menu-ai-clicked-create-${type}-btn`);

      let name = '';
      if(type === 'category')            name = 'Categoria';
      if(type === 'product')             name = 'Produto';
      if(type === 'complement_category') name = 'Categoria de complemento';
      if(type === 'complement')          name = 'Complemento';

      if(!parent.itens) parent.itens = [];
      parent.itens.unshift({
        uuid: crypto.randomUUID(),
        nome: `${name} ${parent.itens.length + 1}`,
        itens: []
      })

      this.$forceUpdate();
      this.mapIds();
    },
    removeItem(parent, type, index, log = true) {
      if(log) this.$eventService.track(`dashboard-admin-menu-ai-clicked-remove-${type}-btn`);

      parent.itens.splice(index, 1);

      this.$forceUpdate();
      this.mapIds();
    },
    removeAllImages(itens, mode) {
      this.initDraggable();

      for(const categoria of itens) {
        if(mode === 'tudo') categoria.img = null;

        if(!categoria.itens) continue;
        for(const produto of categoria.itens) {
          if(mode === 'tudo' || mode === 'produtos') produto.img = null;

          if(!produto.itens) continue;
          for(const cat_complemento of produto.itens) {
            if(mode === 'tudo') cat_complemento.img = null;

            if(!cat_complemento.itens) continue;
            for(let complemento of cat_complemento.itens)
              if(mode === 'tudo' || mode === 'complementos')
                complemento.img = null
          }
        }
      }
    },
    //endregion

    //region Expandable content
    changeProductExpandedState(produto) {
      if(produto.expanded === undefined) produto.expanded = this.productShouldBeExpanded(produto)
      produto.expanded = !produto.expanded;
      this.$forceUpdate()
    },

    // Product expanded if any value is not default
    productShouldBeExpanded(produto) {
      return produto.pesavel === true
        || produto.cod_ean != null
        || produto.cod_pdv != null
        || produto.cod_ncm != null
        || (produto.valor_custo != null && produto.valor_custo !== 0)
    },

    changeComplementCategoryExpandedState(cat_complemento) {
      if(cat_complemento.expanded === undefined) cat_complemento.expanded = this.complementCategoryShouldBeExpanded(cat_complemento);
      cat_complemento.expanded = !cat_complemento.expanded;
      this.$forceUpdate()
    },

    // Complement category expanded if any value is not default
    complementCategoryShouldBeExpanded(cat_complemento) {
      return cat_complemento.minimo != null
        || cat_complemento.maximo != null
    },

    changeComplementExpandedState(complemento) {
      if(complemento.expanded == null) complemento.expanded = this.complementShouldBeExpanded(complemento);
      complemento.expanded = !complemento.expanded;
      this.$forceUpdate()
    },

    // Complement expanded if any value is not default
    complementShouldBeExpanded(complemento) {
      return complemento.cod_pdv != null
    },
    //endregion

    //region Draggable
    remapResultToItens(data) {
      if(!data.categorias) return;

      data.itens = data.categorias;
      delete data.categorias;

      data.itens.forEach((category) => {
        if(!category.produtos) return;

        category.itens = category.produtos;
        delete category.produtos;

        category.itens.forEach((product) => {
          if(!product.cat_complementos) return;

          product.itens = product.cat_complementos;
          delete product.cat_complementos;

          product.itens.forEach((comp_cat) => {
            if(!comp_cat.complementos) return;

            comp_cat.itens = comp_cat.complementos;
            delete comp_cat.complementos;
          })
        })
      });

      return data;
    },


    remapResultFromItens(data) {
      if(!data.itens) return;

      data.categorias = data.itens;
      delete data.itens;

      data.categorias.forEach((category) => {
        if(!category.itens) return;

        category.produtos = category.itens;
        delete category.itens;

        category.produtos.forEach((product) => {
          if(!product.itens) return;

          product.cat_complementos = product.itens;
          delete product.itens;

          product.cat_complementos.forEach((comp_cat) => {
            if(!comp_cat.itens) return;

            comp_cat.complementos = comp_cat.itens;
            delete comp_cat.itens;
          })
        })
      });

      return data;
    },
    initUUIDs(data) {
      if(!data.itens) return;
      data.itens.forEach(item => { // Categories
        item.uuid = crypto.randomUUID();

        if(!item.itens) return;
        item.itens.forEach(item => { // Products
          item.uuid = crypto.randomUUID();
          if(!item.valor_venda) item.valor_venda = 0;
          if(!item.valor_custo) item.valor_custo = 0;

          if(!item.itens) return;
          item.itens.forEach(item => { // Complement categories
            item.uuid = crypto.randomUUID();
            if(!item.valor_venda) item.valor_venda = 0;
            if(!item.valor_custo) item.valor_custo = 0;

            if(!item.itens) return;
            item.itens.forEach(item => { // Complements
              item.uuid = crypto.randomUUID();
              if(!item.valor_venda) item.valor_venda = 0;
              if(!item.valor_custo) item.valor_custo = 0;
            })
          })
        })
      });

      return data;
    },
    mapIds() {
      if(!this.result.itens) return;
      this.result.itens.forEach((category, index) => {
        const cat_id = `${index}`;
        category.drag_id = cat_id;
        category.drag_type = 'category';

        if(!category.itens) return;
        category.itens.forEach((product, index) => {
          const prod_id = cat_id + `,${index}`;
          product.drag_id = prod_id;
          product.drag_type = 'product';

          if(!product.itens) return;
          product.itens.forEach((comp_cat, index) => {
            const comp_cat_id = prod_id + `,${index}`;
            comp_cat.drag_id = comp_cat_id;
            comp_cat.drag_type = 'complement-category';

            if(!comp_cat.itens) return;
            comp_cat.itens.forEach((complement, index) => {
              complement.drag_id = comp_cat_id + `,${index}`;
              complement.drag_type = 'complement';
            })
          })
        })
      });

      this.$forceUpdate();
    },

    /**
     * Emited when a dragged item is dropped.<br/>
     * Verifies if it was dragged to another component and adjusts properties accordingly
     * @param {DragStopEvent} event
     */
    stop(event) {
      if (this.draggable.over == null) return;

      const source_indexes = this.getIndexes(event.data.source);
      const over_indexes   = this.getIndexes(this.draggable.over);

      const source_data   = this.getData(source_indexes);
      const source_parent = this.getParent(source_indexes);

      const over_data   = this.getData(over_indexes);
      const over_parent = this.getParent(over_indexes);

      const source_index = source_parent.indexOf(source_data);
      const over_index   = over_parent.indexOf(over_data);

      // Remove the element from the original array
      // Because we use "indexOf" the remove part has to be done before altering the array
      source_parent.splice(source_index, 1);

      // Insert the element at the index he is over
      over_parent.splice(over_index, 0, source_data);

      this.mapIds(); // Update IDs
      this.$forceUpdate();
    },

    /**
     * Emited when a dragged component is over another component.<br/>
     * When this happens, the component that is "beneath" is saved for when the "stop" event is emited.
     * @param {DragOverEvent} event
     */
    over(event) {
      const source_id = this.getDragId(event.data.source);
      const over_id   = this.getDragId(event.data.over);

      if(source_id === over_id || this.isChild(source_id, over_id)) {
        this.draggable.over = null;
        return;
      }

      this.draggable.over = event.data.over;
    },
    /**
     * Return the drag_id value of a MenuAi component
     * The value is present on a hidden input tag
     * @param {HTMLElement} element
     * @return {string}
     */
    getDragId(element) {
      return element.children[0].value;
    },

    /**
     * Parse all indexes in the drag_id property of the component
     * @param {HTMLElement} element
     * @return {number[]}
     */
    getIndexes(element) {
      return this.getDragId(element).split(',').map(str => Number(str));
    },

    /**
     * Gets the corresponding data at an index map
     * @param {number[]} indexes
     * @return {object} Menu Component at those indexes
     */
    getData(indexes) {
      const drag_id = indexes.join(',');

      const category = this.result.itens[indexes[0]];
      if(category.drag_id === drag_id) return category;

      const product = category.itens[indexes[1]];
      if(product.drag_id === drag_id) return product;

      const comp_cat = product.itens[indexes[2]];
      if(comp_cat.drag_id === drag_id) return comp_cat;

      return comp_cat.itens[indexes[3]];
    },

    /**
     * Return a reference to the array that holds the item in this index
     * @param {number[]} indexes
     * @return {object[]}
     */
    getParent(indexes) {
      const drag_id = indexes.join(',');

      const category = this.result.itens[indexes[0]];
      if(category.drag_id === drag_id) return this.result.itens;

      const product = category.itens[indexes[1]];
      if(product.drag_id === drag_id) return category.itens;

      const comp_cat = product.itens[indexes[2]];
      if(comp_cat.drag_id === drag_id) return product.itens;

      return comp_cat.itens;
    },
    /**
     * Verifies if an element is a child of the source element
     * @param {string} source_id
     * @param {string} over_id
     */
    isChild(source_id, over_id) {
      return over_id.startsWith(source_id + ',');
    },
    initDraggable() {
      if(this.draggable.instance) this.draggable.instance.destroy();

      const draggable = new Draggable(document.querySelectorAll('ul'), {
        draggable: 'li',
        handle: '.draghandle',
        distance: 5,
        mirror: {
          constrainDimensions: true,
        },
      });

      draggable.on('drag:stop', (e) => this.stop(e));
      draggable.on('drag:over', (e) => this.over(e));

      this.draggable.instance = draggable;

      // For some reason this needs to be done
      this.createItem(this.result, 'category', false);
      this.removeItem(this.result, 'category', 0, false)
    }
    //endregion
  },

  mounted() {
    this.$eventService.track("dashboard-admin-menu-ai-viewed-page");

    // for testing
    //this.result = { itens: [] };
    //setTimeout(() => this.initDraggable(), 2000);
  }
}
</script>

<style>

.menu-ia-expanded-content .row {
  display: flex; /* Ativa o layout flexbox */
  align-items: center; /* Alinha verticalmente o label e o input */
  gap: 10px; /* Adiciona espaçamento entre o label e o input */
}

.menu-ia-expanded-content .row label {
  width: 50px; /* Define uma largura fixa para o label */
  text-align: right; /* Alinha o texto do label à direita */
}

.menu-ia-expanded-content .row input {
  flex: 1; /* Faz o input ocupar o restante do espaço */
  text-align: left; /* Alinha o texto dentro do input à direita */
  padding: 5px;
}

.draghandle:hover {
  cursor: pointer;
}

.ai-list-move, /* apply transition to moving elements */
.ai-list-enter-active,
.ai-list-leave-active {
  transition: all 0.25s ease;
}

.ai-list-enter-from,
.ai-list-leave-to {
  opacity: 0;
  transform: translateX(300px) translateY(-150px);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.ai-list-leave-active {
  position: absolute;
}

.catproduto {
  list-style-type: none;
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ccc;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.035);
}

.produto {
  list-style-type: none;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.035);
}

.catcomplemento {
  list-style-type: none;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.035);
}

.complemento {
  list-style-type: none;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.035);
}

.complemento:last-child {
  border: 0;
}

.catproduto:last-child {
  border: 0;
}

.produto:last-child {
  border: 0;
}

.catcomplemento:last-child {
  border: 0;
}

.btn-ia {
  border: 0;
  background-color: #19A1E6;
  color: white;
  border-radius: 100%;
  width: 25px;
  height: 25px;
  justify-content: center;
  align-items: center;
}

.btn-ia.danger {
  background-color: red;
  margin-left: 15px;
}

.input-ia {
  border-radius: 3px;
  border: 1px solid #bbb;
  padding: 5px;
  min-width: 400px;
}

.header-ia {
  display: inline;
  margin-right: 15px;
  font-size: 18px;
  font-weight: 600;
}

.header-ia-2 {
  display: inline;
  margin-right: 15px;
  font-size: 16px;
  font-weight: 600;
}

.header-ia-3 {
  display: inline;
  margin-right: 15px;
  font-size: 16px;
  font-weight: 600;
}

.image-ia:hover {
  outline: 2px solid #ccc;
  cursor: pointer;
}

.upload-ia:hover {
  cursor: pointer;
}

.menu-ia-expandable {
  margin-top: 5px;
  padding: 0;
  border-radius: 5px;
  text-align: center;
}

.menu-ia-expandable:hover{
  outline: 2px solid #ccc;
  cursor: pointer;
}


.action-bar {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.action-bar-buttons {
  display: flex;
}
</style>
